import deepEqual from 'deep-eql';
import React, { useReducer, useEffect } from 'react';
import { buildReferences } from 'utils/SchemaUtils';

const initialState = {
  "schema": null,
  "definitions": {},
  "ready": false
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SCHEMA_CHANGED":
      let ret;
      if(!deepEqual(action.payload, state.schema)){
        ret = {
          ...state,
          schema: action.payload
        }
      } else {
        ret = state;
      }
      return ret;
    case "DEFINITIONS_CHANGED":
      return {
        ...state,
        definitions: action.payload
      }
    case "READY_CHANGED":
      return {
        ...state,
        ready: action.payload
      }
    case "DEFINITION_ADDED":
      return {
        ...state,
        definitions: { ...state.definitions, ...action.payload }
      }
    case "DEFINITION_REMOVED":
      const defs = state.definitions;
      delete defs[action.payload]
      return {
        ...state,
        definitions: defs
      }
    default:
      return state;
  };
};

const FormContext = React.createContext(initialState);

const FormProvider = ({children}) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const updateSchema = React.useCallback((schema) => dispatch({type: "SCHEMA_CHANGED", payload: schema}), []);
  const updateDefinitions = React.useCallback((definitions) => dispatch({type: "DEFINITIONS_CHANGED", payload: definitions}), []);
  const updateReady = React.useCallback((ready) => dispatch({type: "READY_CHANGED", payload: ready}), []);
  const addDefinition = React.useCallback((definition) => dispatch({type: "DEFINITION_ADDED", payload: definition}), []);
  const removeDefinition = React.useCallback((definitionName) => dispatch({type: "DEFINITION_REMOVED", payload: definitionName}), []);

  useEffect(() => {
    let mounted = true;
    const asyncEffect = async () => {
      const references = await buildReferences(state.schema);
      mounted && updateDefinitions(references);
      mounted && updateReady(true);
    };

    state.schema && asyncEffect();

    return () => {mounted = false}
    
  }, [state.schema, updateDefinitions, updateReady])

  return (
    <FormContext.Provider
      value= {{
        definitions: state.definitions,
        schema: state.schema,
        ready: state.ready,
        updateSchema,
        addDefinition,
        removeDefinition,
        updateDefinitions
      }}
    >
      {children}
    </FormContext.Provider>
  )
}

export { FormProvider, FormContext };


